export const firebaseConfig = {
  apiKey: "AIzaSyDUKuImV9f-_ppe46Wou6z3NF76HglWhkc",
  authDomain: "hotel-booking-app-83b33.firebaseapp.com",
  projectId: "hotel-booking-app-83b33",
  storageBucket: "hotel-booking-app-83b33.firebasestorage.app",
  messagingSenderId: "292750556234",
  appId: "1:292750556234:web:f680228c32198c96b83ab3",
  measurementId: "G-BL8B54B2EL"
}; 